import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import { MODAL_ADMIN_EDIT_USER } from 'redux/modules/modals'
const pwd = value => {
  return !!value
}
const defaultColumnData = [
  { id: 'user_id', numeric: false, disablePadding: true, label: 'id' },
  { id: 'user_last_name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'user_first_name',
    numeric: false,
    disablePadding: true,
    label: 'Prénom'
  },
  { id: 'user_email', numeric: false, disablePadding: true, label: 'Email' },
  { id: 'color', numeric: false, disablePadding: false, label: 'Couleur' },
  {
    id: 'passwordHash',
    bool: true,
    disablePadding: true,
    label: 'Password',
    transform: pwd
  },
  {
    id: 'show',
    bool: true,
    disablePadding: true,
    label: 'Actif',
    transform: value => value
  }
]
export default class AdminUsersComponent extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    refreshUsers: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired
  }
  handleEditPlayerClick = user => {
    this.props.showModal(MODAL_ADMIN_EDIT_USER, user)
  }
  componentWillMount() {
    this.props.refreshUsers()
  }
  render() {
    const { users } = this.props
    return (
      <div style={{ paddingTop: 24 }}>
        <AdminTableComponent
          search={['user_id', 'user_last_name', 'user_first_name']}
          title="Utilisateurs"
          readOnly
          list={users}
          orderBy={'user_id'}
          columnData={defaultColumnData}
          editButtonAction={this.handleEditPlayerClick}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Users/components/UsersComponent.js